import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"

const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const getSingleVideoAction = createAsyncThunk(
    'get-single-video',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/singleVideo?video_id=${data?.video_id}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSingleVideoSlice = createSlice({
    name: 'get-single-video',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSingleVideoAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSingleVideoAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
               
            })
            builder.addCase(getSingleVideoAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSingleVideoReducer = getSingleVideoSlice.reducer